// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"54":"modules","191":"moduleB","537":"moduleE","592":"moduleC","602":"moduleD","774":"loginB","900":"moduleA"}[chunkId] + "-legacy." + {"54":"5f8dc7a3","191":"7ab47381","537":"cb060212","592":"33e499c5","602":"4d3e2cf1","774":"bfb5e5b0","900":"74e74ff0"}[chunkId] + ".js";
};